export function isEmptyObject(obj: object) {
  return Object.keys(obj).length === 0;
}
